// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
// import VueAxios from 'vue-axios'
//Vue.use(VueAxios, axios)

//var Less = require('Less');
import less from 'less'
import './permission'
//import 'amfe-flexible/index.js'
//import './style/global.less'
import './style/main.css'
import 'vant/lib/index.css'
import store from './store'
import 'amfe-flexible'
import { create, all } from 'mathjs'
import paramUtil from './components/Utils'
import echarts from 'echarts'

Vue.use(less)
Vue.prototype.$axios = axios
/*import * as math from 'mathjs'
Vue.prototype.$math = math*/
const mathjs = create(all)
mathjs.config({
  number: 'BigNumber',
  precision: 64
})
Vue.prototype.$math = mathjs
Vue.prototype.paramUtil = paramUtil;

Vue.prototype.$echarts = echarts
import { Search, Button,Notify, Col, Row, Tabbar, TabbarItem, Swipe, SwipeItem, Overlay, Sidebar, SidebarItem, Tab, Tabs, Tag, Card, Progress, Pagination, Calendar, DatetimePicker  } from 'vant'
import { Popup } from 'vant'
import { Sticky } from 'vant'
import { Field } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Checkbox, CheckboxGroup } from 'vant'
import { Loading } from 'vant'
import { Dialog } from 'vant'
import { DropdownMenu, DropdownItem } from 'vant'
import { Picker } from 'vant'
import { Empty } from 'vant'
import { Toast } from 'vant'
import { Icon } from 'vant'
import { Image as VanImage } from 'vant'
import { PullRefresh } from 'vant'
import { Cell, CellGroup } from 'vant'
import { Form } from 'vant'
import { AddressEdit } from 'vant'
import { Step, Steps } from 'vant'
import { NavBar } from 'vant'
import { List } from 'vant'
import { ActionSheet } from 'vant'
import {Grid, GridItem } from 'vant'
import Bridge from './config/bridge'
Vue.use(PullRefresh)
Vue.use(Icon)
Vue.use(Col)
Vue.use(Row)
Vue.use(Toast)
Vue.use(Empty)
Vue.use(Picker)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Field)
Vue.use(Sticky)
Vue.use(Popup)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Sidebar)
Vue.use(SidebarItem)
Vue.use(Overlay)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Search)
Vue.use(Notify)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Button)
Vue.use(Tag).use(Card)
Vue.use(VanImage)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Form)
Vue.use(AddressEdit)
Vue.use(Progress)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Pagination)
Vue.use(Calendar)
Vue.use(DatetimePicker)
Vue.use(NavBar)
Vue.use(ActionSheet)
Vue.use(List)
Vue.use(Grid).use(GridItem);
Vue.config.productionTip = false
Vue.prototype.$bridge = Bridge

import wx from 'weixin-js-sdk'
Vue.prototype.$wx = wx;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js